import { Command as CommandPrimitive } from 'cmdk';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';

type CommandEmptyProps = ComponentPropsWithoutRef<typeof CommandPrimitive.Empty>;

const CommandEmpty = forwardRef<HTMLDivElement, CommandEmptyProps>(({ children, ...props }, ref) => (
  <CommandPrimitive.Empty
    ref={ref}
    {...props}
    className="flex flex-col items-center justify-center p-4 text-center text-body-2 text-tertiary"
  >
    {children}
  </CommandPrimitive.Empty>
));

export default CommandEmpty;
